import { render, staticRenderFns } from "./Kundenliste.vue?vue&type=template&id=9c4d812a"
import script from "./Kundenliste.vue?vue&type=script&lang=js"
export * from "./Kundenliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports